import { Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { FddUpload } from "@/components/FddUpload";
import { figuresToForm, NUM_KEYS } from "@/components/franchiseTemplates";

export const newBrand = (extra = {}) => ({ ...EMPTY_BRAND, _k: Math.random().toString(36).slice(2), ...extra });
export const EMPTY_BRAND = { brand: "", category: "", franchise_fee: "", royalty_pct: "", marketing_pct: "", investment_min: "", investment_max: "", fdd_id: "" };
const NUMS = [["franchise_fee", "Initial fee"], ["royalty_pct", "Royalty %"], ["marketing_pct", "Marketing %"], ["investment_min", "Investment low"], ["investment_max", "Investment high"]];
const field = "bg-slate-950/60 border-slate-700 h-9 text-sm";

export const BrandRow = ({ i, b, onChange, onRemove }) => {
  const set = (k) => (e) => onChange({ ...b, [k]: e.target.value });
  return (
    <div className="rounded-xl border border-slate-800 bg-slate-950/40 p-5 space-y-4" data-testid={`compare-brand-row-${i}`}>
      <div className="flex items-center justify-between">
        <p className="text-xs uppercase tracking-wider text-emerald-400 font-semibold">Brand {i + 1}</p>
        {onRemove && <Button type="button" size="icon" variant="ghost" data-testid={`compare-remove-brand-${i}`} onClick={onRemove} className="h-7 w-7 hover:text-rose-400"><X className="h-4 w-4" /></Button>}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Input data-testid={`compare-brand-name-${i}`} value={b.brand} onChange={set("brand")} className={field} placeholder="Franchise brand *" />
        <Input data-testid={`compare-brand-category-${i}`} value={b.category} onChange={set("category")} className={field} placeholder="Category" />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        {NUMS.map(([k, label]) => <label key={k} className="space-y-1 text-[10px] uppercase tracking-wider text-slate-500">{label}<Input data-testid={`compare-brand-${k.replace(/_/g, "-")}-${i}`} type="number" min="0" step="any" value={b[k]} onChange={set(k)} className={`${field} num normal-case`} placeholder="—" /></label>)}
      </div>
      <FddUpload fddId={b.fdd_id} testId={`compare-fdd-${i}`}
        onApply={(d) => onChange({ ...b, ...figuresToForm(d.figures || {}), brand: b.brand || d.figures?.brand || "", fdd_id: d.id })}
        onClear={() => onChange({ ...b, fdd_id: "" })} />
    </div>
  );
};

export const AddBrand = ({ onAdd }) => (
  <Button type="button" variant="outline" data-testid="compare-add-brand" onClick={onAdd} className="w-full rounded-xl border-dashed border-slate-700 bg-transparent text-slate-300"><Plus className="h-4 w-4 mr-1" />Add a third brand</Button>
);

export const brandPayload = ({ _k, ...b }) => ({ ...b, ...Object.fromEntries(NUM_KEYS.map((k) => [k, b[k] === "" || b[k] == null ? null : Number(b[k])])) });
